import { FormControl, TextField, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";
import React from "react";
import ContentNotFound from "../../../../components/mui/general/contentNotFound/contentNotFound";
import { formControlDefaults, textFieldDefaults } from "../../../../helpers/theme/defaultProps";

const NotesTable = (props) => {
	const { notes = [], dateFormat, timeFormat, t } = props
	return (
		<ContentNotFound displayContent={notes.length > 0} message={t('No notes found!')}>
			{notes.map((note) => {
				return (
					<Box key={note?.id}>
						<Grid
							container
							spacing={1}
						>
							<Grid size={12}
								  sx={{ padding: 0.2, marginBottom: 0.8 }}>
								<Box sx={{
									display: 'flex',
									justifyContent: 'space-between',
									background: '#fff5ee',
									paddingLeft: 0.4,
									paddingRight: 0.4
								}}>
									<Typography
										component={'div'}
										variant={'body1'}
										sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
									>
										{note.LoginName}
									</Typography>
									<Typography
										component={'div'}
										variant={'body1'}
										sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
									>
										{note.LastModifiedAt ? dayjs(note.LastModifiedAt).format(`${dateFormat} ${timeFormat}`) : '-'}
									</Typography>
								</Box>
								<FormControl {...formControlDefaults}>
									<TextField
										{...textFieldDefaults}
										name={note?.Body}
										value={note?.Body}
										inputtype="textarea"
										multiline
										rows={3}
										disabled={true}
									/>
								</FormControl>
							</Grid>
						</Grid>
					</Box>
				)
			})}
		</ContentNotFound>
	)
};

export default NotesTable